_N_E =
(window["webpackJsonp_N_E"] = window["webpackJsonp_N_E"] || []).push([[51],{

/***/ "01ar":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var debounce = function debounce(fn, time) {
  var timeout;
  return function debounceTimer() {
    var _this = this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var functionCall = function functionCall() {
      return fn.apply(_this, args);
    };

    clearTimeout(timeout);
    timeout = setTimeout(functionCall, time);
  };
};

/* harmony default export */ __webpack_exports__["a"] = (debounce);

/***/ }),

/***/ "2E4m":
/***/ (function(module, exports) {

module.exports = {"url": "https://soundboks.imgix.net/heroConnection@2x-146bf05c0eaae7acf2cd00ddc6eb4825.jpg", "placeholder": ""};

/***/ }),

/***/ "7Nrg":
/***/ (function(module, exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/media",
      function () {
        return __webpack_require__("CaRH");
      }
    ]);
  

/***/ }),

/***/ "9COk":
/***/ (function(module, exports) {

module.exports = {"url": "https://soundboks.imgix.net/heroConnection@2x-146bf05c0eaae7acf2cd00ddc6eb4825.jpg", "placeholder": "data:image/jpeg;base64,/9j/2wBDAAYEBQYFBAYGBQYHBwYIChAKCgkJChQODwwQFxQYGBcUFhYaHSUfGhsjHBYWICwgIyYnKSopGR8tMC0oMCUoKSj/2wBDAQcHBwoIChMKChMoGhYaKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCj/wAARCAAGABQDASIAAhEBAxEB/8QAFwABAAMAAAAAAAAAAAAAAAAAAAQGB//EAB8QAAIBBAMBAQAAAAAAAAAAAAECAwAEBREGEiExUf/EABYBAQEBAAAAAAAAAAAAAAAAAAMBAv/EAB4RAAEEAQUAAAAAAAAAAAAAAAEAAgMRISIxQZHw/9oADAMBAAIRAxEAPwDMuIZjJ28eTxkc6MwlaGFpFDLG2iW2NeqT7r9AqxS8rueW4qSG0trawzDz9Lm4VB1uUXRJJ0SGMh7eflKUW5N+wpLpYwt5BvtR83lcxNNbSSWODdjAoLyRlmbW12fPPnylKVq0MhIcV//Z"};

/***/ }),

/***/ "A05/":
/***/ (function(module, exports) {

module.exports = { "url": "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB2aWV3Qm94PSIwIDAgMzAgMzAiPgogIDxkZWZzPgogICAgPHN0eWxlPgogICAgICAuY2xzLTEgewogICAgICAgIGNsaXAtcGF0aDogdXJsKCNjbGlwLWFycm93X3NvbGlkX3doaXRlKTsKICAgICAgfQoKICAgICAgLmNscy0yIHsKICAgICAgICBmaWxsOiAjMjEyMjIyOwogICAgICB9CgogICAgICAuY2xzLTMgewogICAgICAgIGZpbGw6IG5vbmU7CiAgICAgIH0KICAgIDwvc3R5bGU+CiAgICA8Y2xpcFBhdGggaWQ9ImNsaXAtYXJyb3dfc29saWRfd2hpdGUiPgogICAgICA8cmVjdCB3aWR0aD0iMzAiIGhlaWdodD0iMzAiLz4KICAgIDwvY2xpcFBhdGg+CiAgPC9kZWZzPgogIDxnIGlkPSJhcnJvd19zb2xpZF93aGl0ZSIgY2xhc3M9ImNscy0xIj4KICAgIDxwYXRoIGlkPSJQYXRoXzE1MzUiIGRhdGEtbmFtZT0iUGF0aCAxNTM1IiBjbGFzcz0iY2xzLTIiIGQ9Ik0zMCwxMS40SDEwLjA1bDcuNzI1LTcuNzI1TDE0LjAyNSwwLDMuNjc1LDEwLjM1LDAsMTQuMDI1SDBMMi45MjUsMTYuOTVsMTEuMSwxMS4xLDMuNzUtMy42NzVMMTAuMDUsMTYuNjVIMzBaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgwIDAuNzUpIi8+CiAgICA8cmVjdCBpZD0iUmVjdGFuZ2xlXzIxMjYiIGRhdGEtbmFtZT0iUmVjdGFuZ2xlIDIxMjYiIGNsYXNzPSJjbHMtMyIgd2lkdGg9IjMwIiBoZWlnaHQ9IjMwIi8+CiAgPC9nPgo8L3N2Zz4K" };

/***/ }),

/***/ "CaRH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__("q1tI");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./components/shared/Meta/index.js + 6 modules
var Meta = __webpack_require__("ACIN");

// EXTERNAL MODULE: ./components/wrappers/Layout/index.js + 33 modules
var Layout = __webpack_require__("8hyx");

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/toConsumableArray.js + 3 modules
var toConsumableArray = __webpack_require__("KQm4");

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 3 modules
var slicedToArray = __webpack_require__("ODXe");

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/classCallCheck.js
var classCallCheck = __webpack_require__("1OyB");

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/createClass.js
var createClass = __webpack_require__("vuIU");

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js
var assertThisInitialized = __webpack_require__("JX7q");

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/inherits.js
var inherits = __webpack_require__("Ji7U");

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js
var possibleConstructorReturn = __webpack_require__("md7G");

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js
var getPrototypeOf = __webpack_require__("foSv");

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("rePB");

// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__("20a2");
var router_default = /*#__PURE__*/__webpack_require__.n(next_router);

// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js
var styled_components_browser_esm = __webpack_require__("vOnD");

// EXTERNAL MODULE: ./components/shared/Row/index.js
var Row = __webpack_require__("OfJt");

// EXTERNAL MODULE: ./utils/paramToResolutions.js
var paramToResolutions = __webpack_require__("vE80");

// EXTERNAL MODULE: ./data/media.js
var media = __webpack_require__("+ybw");

// EXTERNAL MODULE: ./utils/debounce.js
var debounce = __webpack_require__("01ar");

// EXTERNAL MODULE: ./node_modules/@lingui/react/index.js
var _lingui_react = __webpack_require__("ZD0w");

// EXTERNAL MODULE: ./components/shared/Composition/index.js + 27 modules
var Composition = __webpack_require__("FpTs");

// CONCATENATED MODULE: ./components/pages/Media/Hero/configuration/imageSources.js
var imageSources = {};
imageSources.heroMobile = __webpack_require__("2E4m");
imageSources.heroTablet = __webpack_require__("9COk");
imageSources.heroDesktop = __webpack_require__("2E4m");
imageSources.heroDesktopLarge = __webpack_require__("2E4m");
/* harmony default export */ var configuration_imageSources = (imageSources);
// CONCATENATED MODULE: ./components/pages/Media/Hero/index.js
var __jsx = react_default.a.createElement;






var Hero_Hero = function Hero() {
  return /*#__PURE__*/react_default.a.createElement(Container, null, /*#__PURE__*/react_default.a.createElement(Composition["s" /* default */], {
    content: /*#__PURE__*/react_default.a.createElement(react_default.a.Fragment, null, /*#__PURE__*/react_default.a.createElement(Composition["j" /* LayoutBackground */], {
      content: /*#__PURE__*/react_default.a.createElement(react_default.a.Fragment, null, /*#__PURE__*/react_default.a.createElement(Composition["b" /* BackgroundSolidColor */], {
        colorName: "black4"
      }), /*#__PURE__*/react_default.a.createElement(Composition["g" /* Image */], {
        sourceSet: {
          mobile: configuration_imageSources.heroMobile.url,
          tablet: configuration_imageSources.heroTablet.url,
          desktop: configuration_imageSources.heroDesktop.url,
          desktopLarge: configuration_imageSources.heroDesktopLarge.url,
          placeholder: configuration_imageSources.heroTablet.placeholder
        },
        objectFit: "cover",
        objectPosition: "center center"
      }))
    }), /*#__PURE__*/react_default.a.createElement(Composition["i" /* LayoutAlignEndCenter */], {
      content: /*#__PURE__*/react_default.a.createElement(Composition["r" /* TextHeadingTape */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
        id: "MEDIA"
      }))
    }))
  }));
};

var Container = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Hero__Container",
  componentId: "sc-1w5umcq-0"
})(["display:flex;height:70vh;"]);
/* harmony default export */ var Media_Hero = (Hero_Hero);
// EXTERNAL MODULE: ./components/pages/Media/controlElements.js
var controlElements = __webpack_require__("adeU");

// CONCATENATED MODULE: ./components/pages/Media/Controls.js
var Controls_jsx = react_default.a.createElement;





var Wrapper = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Controls__Wrapper",
  componentId: "xpjobv-0"
})(["display:grid;grid-template:'filters' 'search' / 1fr;@media ", "{grid-template:'search' 'filters' / 1fr;}@media ", "{grid-template:'filters filters search' / 1fr 1fr 1fr;grid-column-gap:20px;}"], function (props) {
  return props.theme.breakpoints.tablet;
}, function (props) {
  return props.theme.breakpoints.desktop;
});
var SearchWrapper = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Controls__SearchWrapper",
  componentId: "xpjobv-1"
})(["grid-area:search;@media ", "{width:336px;margin:0 auto 50px;}@media ", "{width:auto;margin:0;}"], function (props) {
  return props.theme.breakpoints.tablet;
}, function (props) {
  return props.theme.breakpoints.desktop;
});
var FiltersWrapper = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Controls__FiltersWrapper",
  componentId: "xpjobv-2"
})(["display:grid;grid-area:filters;grid-template-columns:repeat(2,1fr);grid-row-gap:8px;grid-column-gap:8px;", ";@media ", "{grid-template-columns:repeat(3,1fr);> div:nth-child(3){display:none;}> div:last-child{grid-column-start:1;grid-column-end:4;}}@media ", "{grid-template-columns:repeat(4,1fr);> div:nth-child(3){display:none;}> div:last-child{grid-row-start:1;grid-row-end:2;grid-column-start:4;grid-column-end:5;}}@media ", "{> div:nth-child(3){display:", ";}}"], Object(paramToResolutions["a" /* default */])('margin-bottom', [50, 0, 0, 0]), function (props) {
  return props.theme.breakpoints.onlyTablet;
}, function (props) {
  return props.theme.breakpoints.desktop;
}, function (props) {
  return props.theme.breakpoints.tablet;
}, function (props) {
  return props.filtersCount > 3 ? 'none' : 'block';
});

var Controls_Controls = function Controls(_ref) {
  var search = _ref.search,
      filter = _ref.filter,
      showAllFilters = _ref.showAllFilters,
      onSearchChange = _ref.onSearchChange,
      onFilterChange = _ref.onFilterChange,
      onToggleFilterOpen = _ref.onToggleFilterOpen,
      availableFilters = _ref.availableFilters;
  var filtersToShow = showAllFilters ? availableFilters : availableFilters.slice(0, 4);
  return /*#__PURE__*/react_default.a.createElement(Wrapper, null, /*#__PURE__*/react_default.a.createElement(FiltersWrapper, {
    filtersCount: filtersToShow.length
  }, filtersToShow.map(function (title) {
    return /*#__PURE__*/react_default.a.createElement(controlElements["a" /* FilterButton */], {
      key: title,
      title: title,
      onClick: onFilterChange,
      active: filter === title
    });
  }), /*#__PURE__*/react_default.a.createElement(controlElements["b" /* MoreFiltersButton */], {
    onClick: onToggleFilterOpen,
    showAllFilters: showAllFilters
  })), /*#__PURE__*/react_default.a.createElement(SearchWrapper, null, /*#__PURE__*/react_default.a.createElement(_lingui_react["I18n"], null, function (_ref2) {
    var i18n = _ref2.i18n;
    return /*#__PURE__*/react_default.a.createElement(controlElements["d" /* SearchInput */], {
      value: search,
      onChange: onSearchChange,
      placeholder: i18n._(
      /*i18n*/
      {
        id: "Type your search"
      })
    });
  })));
};

/* harmony default export */ var Media_Controls = (Controls_Controls);
// EXTERNAL MODULE: ./components/atoms/Text/mixins/highlightMixins.js
var highlightMixins = __webpack_require__("8BqB");

// EXTERNAL MODULE: ./components/shared/ReviewComponents/index.js + 5 modules
var ReviewComponents = __webpack_require__("wjrY");

// EXTERNAL MODULE: ./components/atoms/Text/index.js + 17 modules
var Text = __webpack_require__("wCgk");

// CONCATENATED MODULE: ./components/pages/Media/VideoItem.js
var VideoItem_jsx = react_default.a.createElement;





var VideoItem_VideoItem = function VideoItem(props) {
  var id = props.id,
      onCategoryClick = props.onCategoryClick,
      category = props.category,
      title = props.title,
      description = props.description,
      onVideoClick = props.onVideoClick;
  return /*#__PURE__*/react_default.a.createElement(VideoItem_Wrapper, null, /*#__PURE__*/react_default.a.createElement(ReviewComponents["d" /* YoutubeVideo */], {
    keepRatio: true,
    id: id,
    onClick: onVideoClick
  }), /*#__PURE__*/react_default.a.createElement(ContentWrapper, null, /*#__PURE__*/react_default.a.createElement(Text["f" /* H4 */], null, title), /*#__PURE__*/react_default.a.createElement(Text["n" /* Subtitle */], null, description), /*#__PURE__*/react_default.a.createElement(CategoryText, null, category.map(function (c) {
    return /*#__PURE__*/react_default.a.createElement("span", {
      key: c,
      onClick: function onClick() {
        return onCategoryClick(c);
      }
    }, c);
  }))));
};

var VideoItem_Wrapper = styled_components_browser_esm["default"].div.withConfig({
  displayName: "VideoItem__Wrapper",
  componentId: "sc-1puiyzj-0"
})(["z-index:1;width:100%;min-height:200px;display:flex;flex-direction:column;background-color:", ";box-shadow:", ";"], function (props) {
  return props.theme.colors.white;
}, function (props) {
  return props.theme.shadows.standard;
});
var ContentWrapper = styled_components_browser_esm["default"].div.withConfig({
  displayName: "VideoItem__ContentWrapper",
  componentId: "sc-1puiyzj-1"
})(["display:flex;flex-direction:column;padding:16px;flex-grow:1;@media ", "{padding:30px 24px 20px;}p:first-of-type{margin-bottom:20px;}"], function (props) {
  return props.theme.breakpoints.desktopLarge;
});
var CategoryText = Object(styled_components_browser_esm["default"])(Text["n" /* Subtitle */]).withConfig({
  displayName: "VideoItem__CategoryText",
  componentId: "sc-1puiyzj-2"
})(["color:", ";margin-top:auto;font-weight:bold;span{display:inline-block;cursor:pointer;&:not(:last-child):after{content:',';display:inline-block;margin-right:3px;}}"], function (props) {
  return props.theme.colors.grey2;
});
/* harmony default export */ var Media_VideoItem = (VideoItem_VideoItem);
// CONCATENATED MODULE: ./components/pages/Media/VideosList.js
var VideosList_jsx = react_default.a.createElement;






var VideosList_VideosList = function VideosList(_ref) {
  var items = _ref.items,
      onCategoryClick = _ref.onCategoryClick,
      _onVideoClick = _ref.onVideoClick;
  return /*#__PURE__*/react_default.a.createElement(VideosList_Wrapper, null, /*#__PURE__*/react_default.a.createElement(BackgroundText, null, "GO ", /*#__PURE__*/react_default.a.createElement("br", null), "ANYWHERE.", /*#__PURE__*/react_default.a.createElement("span", null, /*#__PURE__*/react_default.a.createElement("br", null), "GO ANYWHERE.", /*#__PURE__*/react_default.a.createElement("br", null), "GO ANYWHERE.", /*#__PURE__*/react_default.a.createElement("br", null), "GO ANYWHERE.")), items.map(function (item) {
    return /*#__PURE__*/react_default.a.createElement(Media_VideoItem, {
      key: item.id,
      onCategoryClick: onCategoryClick,
      onVideoClick: function onVideoClick() {
        return _onVideoClick(item.id);
      },
      videoId: item.videoId,
      type: item.type,
      title: item.title,
      description: item.description,
      category: item.category,
      id: item.id
    });
  }));
};

var VideosList_Wrapper = styled_components_browser_esm["default"].div.withConfig({
  displayName: "VideosList__Wrapper",
  componentId: "cv0gmh-0"
})(["position:relative;display:grid;grid-template-columns:1fr;grid-row-gap:16px;grid-column-gap:16px;@media ", "{grid-template-columns:1fr 1fr;}@media ", "{grid-template-columns:1fr 1fr 1fr;grid-row-gap:20px;grid-column-gap:20px;}"], function (props) {
  return props.theme.breakpoints.tablet;
}, function (props) {
  return props.theme.breakpoints.desktop;
});
var BackgroundText = styled_components_browser_esm["default"].div.withConfig({
  displayName: "VideosList__BackgroundText",
  componentId: "cv0gmh-1"
})(["", ";position:absolute;", ";", ";@media ", "{> br{display:none;}}@media ", "{span{display:none;}}"], highlightMixins["c" /* highlightMixin3 */], Object(paramToResolutions["a" /* default */])('top', [-28, 40, 280, 340]), Object(paramToResolutions["a" /* default */])('left', [-16, -46, undefined, -150]), function (props) {
  return props.theme.breakpoints.onlyMobile;
}, function (props) {
  return props.theme.breakpoints.tablet;
});
/* harmony default export */ var Media_VideosList = (VideosList_VideosList);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__("Vvt1");
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);

// CONCATENATED MODULE: ./components/pages/Media/VideoModal.js
var VideoModal_jsx = react_default.a.createElement;

/* eslint-disable no-unused-vars */







var Modal = dynamic_default()(function () {
  return __webpack_require__.e(/* import() */ 29).then(__webpack_require__.bind(null, "B+EU"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("B+EU")];
    },
    modules: ['components/shared/Modal']
  }
});
var WrapperComponent = styled_components_browser_esm["default"].div.withConfig({
  displayName: "VideoModal__WrapperComponent",
  componentId: "sc-753li5-0"
})(["background-color:", ";position:relative;", ";"], function (props) {
  return props.theme.colors.white;
}, Object(paramToResolutions["a" /* default */])('width', ['100%', '90vw', null, null]));

var VideoModal_VideoModal = function VideoModal(_ref) {
  var id = _ref.id,
      onClose = _ref.onClose,
      onCategoryClick = _ref.onCategoryClick;
  var video = media["a" /* default */].byId[id];
  return /*#__PURE__*/react_default.a.createElement(Modal, {
    onClose: onClose,
    WrapperComponent: WrapperComponent
  }, /*#__PURE__*/react_default.a.createElement(VideoModal_Wrapper, null, /*#__PURE__*/react_default.a.createElement(VideoWrapper, null, /*#__PURE__*/react_default.a.createElement(ReviewComponents["d" /* YoutubeVideo */], {
    id: id,
    autoplay: true
  })), /*#__PURE__*/react_default.a.createElement(DescriptionWrapper, null, /*#__PURE__*/react_default.a.createElement(VideoTitle, null, video.title), /*#__PURE__*/react_default.a.createElement(VideoDescription, null, video.description), /*#__PURE__*/react_default.a.createElement(VideoCategory, null, video.category.map(function (cat) {
    return /*#__PURE__*/react_default.a.createElement("span", {
      key: cat,
      onClick: function onClick() {
        return onCategoryClick(cat);
      }
    }, cat);
  })))));
};

var VideoModal_Wrapper = styled_components_browser_esm["default"].div.withConfig({
  displayName: "VideoModal__Wrapper",
  componentId: "sc-753li5-1"
})(["height:100%;display:flex;flex-direction:column;"]);
var VideoWrapper = styled_components_browser_esm["default"].div.withConfig({
  displayName: "VideoModal__VideoWrapper",
  componentId: "sc-753li5-2"
})(["width:100%;height:100%;", ";"], Object(paramToResolutions["a" /* default */])('height', [290, 480, 540, 730]));
var DescriptionWrapper = styled_components_browser_esm["default"].div.withConfig({
  displayName: "VideoModal__DescriptionWrapper",
  componentId: "sc-753li5-3"
})(["display:flex;flex-direction:column;flex-grow:1;", ";"], Object(paramToResolutions["a" /* default */])('padding', [24, 40, '40px 80px', '70px 110px']));
var VideoTitle = styled_components_browser_esm["default"].h1.withConfig({
  displayName: "VideoModal__VideoTitle",
  componentId: "sc-753li5-4"
})(["margin-top:0;", ";", ";", ";"], Object(paramToResolutions["a" /* default */])('font-size', [20, 36, undefined, 50]), Object(paramToResolutions["a" /* default */])('line-height', [24, 40, undefined, 60]), Object(paramToResolutions["a" /* default */])('margin-bottom', [10, 15, undefined, 20]));
var VideoDescription = styled_components_browser_esm["default"].p.withConfig({
  displayName: "VideoModal__VideoDescription",
  componentId: "sc-753li5-5"
})(["margin:0;", ";", ";@media ", "{font-weight:bold;}"], Object(paramToResolutions["a" /* default */])('font-size', [12, 20, undefined, 30]), Object(paramToResolutions["a" /* default */])('line-height', [16, 30, undefined, 40]), function (props) {
  return props.theme.breakpoints.tablet;
});
var VideoCategory = Object(styled_components_browser_esm["default"])(Text["n" /* Subtitle */]).withConfig({
  displayName: "VideoModal__VideoCategory",
  componentId: "sc-753li5-6"
})(["margin-top:", "px;color:", ";font-weight:bold;justify-self:flex-end;span{display:inline-block;cursor:pointer;&:not(:last-child):after{content:',';display:inline-block;margin-right:3px;}}"], function (props) {
  return props.theme.baseline * 3;
}, function (props) {
  return props.theme.colors.grey2;
});
/* harmony default export */ var Media_VideoModal = (VideoModal_VideoModal);
// CONCATENATED MODULE: ./components/pages/Media/index.js









var Media_jsx = react_default.a.createElement;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Object(getPrototypeOf["a" /* default */])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Object(getPrototypeOf["a" /* default */])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Object(possibleConstructorReturn["a" /* default */])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }














var Media_Media = /*#__PURE__*/function (_Component) {
  Object(inherits["a" /* default */])(Media, _Component);

  var _super = _createSuper(Media);

  function Media(props) {
    var _this;

    Object(classCallCheck["a" /* default */])(this, Media);

    _this = _super.call(this, props); // supply vid id to every vid

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "handleFilterChange", function (filter) {
      return _this.setState(function (prevState) {
        return {
          filter: filter === prevState.filter ? '' : filter
        };
      }, _this.debouncedGetMedia);
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "handleSearchChange", function (e) {
      _this.setState({
        search: e.target.value.toLowerCase()
      }, _this.debouncedGetMedia);
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "handlePageChange", function (page) {
      _this.setState({
        page: page
      });

      var scrollTo = document.getElementById('media_controls');
      if (scrollTo) scrollTo.scrollIntoView();
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "toggleFilterOpen", function () {
      return _this.setState(function (prevState) {
        return _objectSpread(_objectSpread({}, prevState), {}, {
          showAllFilters: !prevState.showAllFilters
        });
      });
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "paginateItems", function () {
      var _this$state = _this.state,
          page = _this$state.page,
          filteredVideos = _this$state.filteredVideos;
      var firstItem = (page - 1) * _this.itemsPerPage;
      var lastItem = firstItem + _this.itemsPerPage;
      return filteredVideos.slice(firstItem, lastItem);
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "openVideoModal", function (id) {
      var pathname = router_default.a.pathname;
      var href = "".concat(pathname, "?videoId=").concat(id);
      router_default.a.push(href, href, {
        shallow: true
      });
      var videoList = Object.values(media["a" /* default */].byId); // TODO: Show notification if video not available

      var selectedVideo = videoList.find(function (video) {
        return video.videoId === id;
      });
      if (id && !!selectedVideo) _this.changeVideoId(id);
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "closeVideoModal", function () {
      router_default.a.push(router_default.a.pathname);

      _this.changeVideoId(null);
    });

    _this.allVideos = Object.entries(media["a" /* default */].byId).map(function (_ref) {
      var _ref2 = Object(slicedToArray["a" /* default */])(_ref, 2),
          key = _ref2[0],
          value = _ref2[1];

      return _objectSpread(_objectSpread({}, value), {}, {
        id: key
      });
    }); // Extracting Categories from a list of videos

    _this.availableFilters = _this.allVideos.reduce(function (acc, i) {
      var vidCategory = i.category || [];
      vidCategory.forEach(function (cat) {
        return acc.indexOf(cat) < 0 ? acc.push(cat) : null;
      });
      return acc;
    }, []);
    _this.state = {
      page: 1,
      search: '',
      filter: '',
      showAllFilters: false,
      filteredVideos: _this.allVideos
    };
    _this.itemsPerPage = 6;
    _this.debouncedGetMedia = Object(debounce["a" /* default */])(_this.getMedia, 450);
    return _this;
  }

  Object(createClass["a" /* default */])(Media, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      var router = this.props.router;
      var _router$query = router.query,
          videoId = _router$query.videoId,
          filter = _router$query.filter;
      var videoList = Object.values(media["a" /* default */].byId);

      if (filter) {
        setTimeout(function () {
          _this2.setState({
            filter: filter
          });

          _this2.getMedia();
        }, 0);
      }

      var selectedVideo = videoList.find(function (video) {
        return video.id === videoId;
      });

      if (videoId && !!selectedVideo) {
        this.changeVideoId(videoId);
      }
    } // Get media

  }, {
    key: "getMedia",
    value: function getMedia() {
      var _this$state2 = this.state,
          filter = _this$state2.filter,
          search = _this$state2.search;

      var filteredVideos = Object(toConsumableArray["a" /* default */])(this.allVideos); // filter by category


      if (filter.length) {
        filteredVideos = filteredVideos.filter(function (_ref3) {
          var category = _ref3.category;
          return category.indexOf(filter) >= 0;
        });
      } // Filter by search field, check title and description


      if (search) {
        filteredVideos = filteredVideos.filter(function (_ref4) {
          var title = _ref4.title,
              description = _ref4.description;
          return title.toLowerCase().indexOf(search) >= 0 || description.toLowerCase().indexOf(search) >= 0;
        });
      } // update state and reset page


      this.setState({
        filteredVideos: filteredVideos,
        page: 1
      });
    }
  }, {
    key: "changeVideoId",
    value: function changeVideoId(videoId) {
      var openedVideoId = this.state.openedVideoId;

      if (openedVideoId !== videoId) {
        this.setState({
          openedVideoId: videoId
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var itemsToShow = this.paginateItems();
      var _this$state3 = this.state,
          page = _this$state3.page,
          filteredVideos = _this$state3.filteredVideos,
          openedVideoId = _this$state3.openedVideoId,
          search = _this$state3.search,
          filter = _this$state3.filter,
          showAllFilters = _this$state3.showAllFilters;
      return /*#__PURE__*/react_default.a.createElement("div", null, /*#__PURE__*/react_default.a.createElement(Media_Hero, null), /*#__PURE__*/react_default.a.createElement(ContentRow, {
        id: "media_controls"
      }, /*#__PURE__*/react_default.a.createElement(Media_Controls, {
        page: page,
        search: search,
        filter: filter,
        showAllFilters: showAllFilters,
        filteredVideos: filteredVideos,
        availableFilters: this.availableFilters,
        onFilterChange: this.handleFilterChange,
        onSearchChange: this.handleSearchChange,
        onToggleFilterOpen: this.toggleFilterOpen
      }), /*#__PURE__*/react_default.a.createElement(Media_VideosList, {
        items: itemsToShow,
        onCategoryClick: this.handleFilterChange,
        onVideoClick: this.openVideoModal
      }), /*#__PURE__*/react_default.a.createElement(controlElements["c" /* Pagination */], {
        page: page,
        perPage: this.itemsPerPage,
        total: filteredVideos.length,
        onPageChange: this.handlePageChange
      }), openedVideoId && /*#__PURE__*/react_default.a.createElement(Media_VideoModal, {
        id: openedVideoId,
        onClose: this.closeVideoModal,
        onCategoryClick: this.handleFilterChange
      })));
    }
  }]);

  return Media;
}(react["Component"]);

var ContentRow = Object(styled_components_browser_esm["default"])(Row["a" /* default */]).withConfig({
  displayName: "Media__ContentRow",
  componentId: "sc-1y646t8-0"
})(["", ";", ";> div:nth-child(1){", ";}> div:nth-child(2){", ";}"], Object(paramToResolutions["a" /* default */])('padding-top', [100, 100, 100, 180]), Object(paramToResolutions["a" /* default */])('padding-bottom', [30, 95, 60, 100]), Object(paramToResolutions["a" /* default */])('margin-bottom', [40, 50, 60, 70]), Object(paramToResolutions["a" /* default */])('margin-bottom', [30, 100, 60, 100]));
/* harmony default export */ var pages_Media = (Object(next_router["withRouter"])(Media_Media));
// CONCATENATED MODULE: ./pages/media.js
var media_jsx = react_default.a.createElement;





var media_StoryPage = function StoryPage() {
  var pageInfo = {
    title:
    /*i18n*/
    {
      id: "media.meta.title"
    },
    desc:
    /*i18n*/
    {
      id: "media.meta.description"
    },
    url: '/media'
  };
  return /*#__PURE__*/react_default.a.createElement(Layout["a" /* default */], null, /*#__PURE__*/react_default.a.createElement(Meta["a" /* default */], {
    pageInfo: pageInfo
  }), /*#__PURE__*/react_default.a.createElement(pages_Media, null));
};

/* harmony default export */ var pages_media = __webpack_exports__["default"] = (media_StoryPage);

/***/ }),

/***/ "adeU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return SearchInput; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FilterButton; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return MoreFiltersButton; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return Pagination; });
/* harmony import */ var _lingui_react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ZD0w");
/* harmony import */ var _lingui_react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_lingui_react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("q1tI");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("vOnD");
/* harmony import */ var utils_paramToResolutions__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("vE80");
var __jsx = react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement;





var arrowIcon = __webpack_require__("A05/");

var borderedTemplate = Object(styled_components__WEBPACK_IMPORTED_MODULE_2__["css"])(["height:40px;border:3px solid ", ";padding:0 10px;display:flex;align-items:center;", ";", ";color:", ";background-color:", ";@media ", "{height:50px;}"], function (props) {
  return props.theme.colors.black;
}, Object(utils_paramToResolutions__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"])('font-size', [16, 15, undefined, 20]), Object(utils_paramToResolutions__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"])('line-height', [24, 20, undefined, 30]), function (_ref) {
  var active = _ref.active,
      colors = _ref.theme.colors;
  return active ? colors.white : colors.black;
}, function (_ref2) {
  var active = _ref2.active,
      colors = _ref2.theme.colors;
  return active ? colors.black : colors.white;
}, function (props) {
  return props.theme.breakpoints.desktopLarge;
});
var SearchWrapper = styled_components__WEBPACK_IMPORTED_MODULE_2__["default"].div.withConfig({
  displayName: "controlElements__SearchWrapper",
  componentId: "sc-13n9sdl-0"
})(["", ";"], borderedTemplate);
var SearchInputWrapper = styled_components__WEBPACK_IMPORTED_MODULE_2__["default"].input.withConfig({
  displayName: "controlElements__SearchInputWrapper",
  componentId: "sc-13n9sdl-1"
})(["text-transform:uppercase;border:none;width:100%;&:focus{outline:none;}::placeholder{color:", ";}"], function (props) {
  return props.theme.colors.grey4;
});
var ArrowIcon = styled_components__WEBPACK_IMPORTED_MODULE_2__["default"].div.withConfig({
  displayName: "controlElements__ArrowIcon",
  componentId: "sc-13n9sdl-2"
})(["height:20px;width:30px;background:url(", ") center no-repeat;background-size:contain;cursor:pointer;transition:0.3s ease-in-out transform;@media ", "{height:30px;}", " ", " ", " ", ""], arrowIcon.url, function (props) {
  return props.theme.breakpoints.desktopLarge;
}, function (props) {
  return props.direction === 'right' && "\n    transform: scale(-1);\n  ";
}, function (props) {
  return props.direction === 'up' && "\n    transform: rotate(90deg);\n  ";
}, function (props) {
  return props.direction === 'down' && "\n    transform: rotate(-90deg);\n  ";
}, function (props) {
  return props.disabled && 'opacity: 0.5;';
});
var SearchInput = function SearchInput(_ref3) {
  var arrowId = _ref3.arrowId,
      onChange = _ref3.onChange,
      value = _ref3.value;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement(SearchWrapper, null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement(SearchInputWrapper, {
    onChange: onChange,
    value: value
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement(ArrowIcon, {
    direction: "right",
    id: arrowId || 'media-content__button--search'
  }));
};
SearchInput.defaultProps = {
  arrowId: null
};
var FilterWrapper = styled_components__WEBPACK_IMPORTED_MODULE_2__["default"].div.withConfig({
  displayName: "controlElements__FilterWrapper",
  componentId: "sc-13n9sdl-3"
})(["", ";justify-content:center;text-transform:uppercase;font-weight:bold;white-space:nowrap;cursor:pointer;transition:all 0.15s ease;&:hover{transform:translateY(-1px);}@media ", "{font-size:", "px;}"], borderedTemplate, function (props) {
  return props.theme.breakpoints.onlyMobile;
}, function (props) {
  return props.theme.halfBaseline * 3;
});
var FilterButton = function FilterButton(_ref4) {
  var title = _ref4.title,
      _onClick = _ref4.onClick,
      active = _ref4.active;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement(FilterWrapper, {
    id: "media-content__button-".concat(title.replace(/\s+/g, '-')),
    onClick: function onClick() {
      return _onClick(title);
    },
    active: active
  }, title);
};
FilterButton.defaultProps = {
  active: false
};
var MoreFiltersWrapper = styled_components__WEBPACK_IMPORTED_MODULE_2__["default"].div.withConfig({
  displayName: "controlElements__MoreFiltersWrapper",
  componentId: "sc-13n9sdl-4"
})(["height:40px;display:flex;justify-content:center;align-items:center;", ";font-weight:bold;cursor:pointer;"], Object(utils_paramToResolutions__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"])('font-size', [16, 12, undefined, 15]));
var MoreFiltersButton = function MoreFiltersButton(_ref5) {
  var onClick = _ref5.onClick,
      showAllFilters = _ref5.showAllFilters;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement(MoreFiltersWrapper, {
    onClick: onClick
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement(ArrowIcon, {
    direction: showAllFilters ? 'up' : 'down'
  }), ' ', showAllFilters ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement(_lingui_react__WEBPACK_IMPORTED_MODULE_0__["Trans"], {
    id: "less filters"
  }) : /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement(_lingui_react__WEBPACK_IMPORTED_MODULE_0__["Trans"], {
    id: "more filters"
  }));
};
var PaginationWrapper = styled_components__WEBPACK_IMPORTED_MODULE_2__["default"].div.withConfig({
  displayName: "controlElements__PaginationWrapper",
  componentId: "sc-13n9sdl-5"
})(["display:flex;align-items:center;justify-content:center;> *:not(:last-child){margin-right:16px;}margin:0 auto;"]);
var Page = styled_components__WEBPACK_IMPORTED_MODULE_2__["default"].div.withConfig({
  displayName: "controlElements__Page",
  componentId: "sc-13n9sdl-6"
})(["", ";min-width:40px;font-weight:bold;font-family:", ";cursor:pointer;padding:0;justify-content:center;text-align:center;@media ", "{min-width:50px;}transition:all 0.15s ease;&:hover{transform:translateY(-1px);}"], borderedTemplate, function (props) {
  return props.theme.fonts.main;
}, function (props) {
  return props.theme.breakpoints.desktopLarge;
});
var Pagination = function Pagination(_ref6) {
  var page = _ref6.page,
      total = _ref6.total,
      perPage = _ref6.perPage,
      onPageChange = _ref6.onPageChange;
  var totalPages = Math.ceil(total / perPage);

  if (!total) {
    return null;
  }

  var pages = [];
  var prevPage = page > 1 ? page - 1 : null;
  var nextPage = page < totalPages ? page + 1 : null;
  var afterNextPage = page + 2 <= totalPages ? page + 2 : null;
  pages.push(prevPage);
  pages.push(page);
  pages.push(nextPage);
  pages.push(afterNextPage);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement(PaginationWrapper, null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement(ArrowIcon, {
    direction: "left",
    disabled: !prevPage,
    onClick: function onClick() {
      return prevPage ? onPageChange(prevPage) : null;
    }
  }), pages.map(function (p) {
    return p ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement(Page, {
      key: p,
      active: p === page,
      onClick: function onClick() {
        return onPageChange(p);
      }
    }, p > 10 ? p : "0".concat(p)) : null;
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement(ArrowIcon, {
    direction: "right",
    disabled: !nextPage,
    onClick: function onClick() {
      return nextPage ? onPageChange(nextPage) : null;
    }
  }));
};

/***/ }),

/***/ "cDf5":
/***/ (function(module, exports) {

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    module.exports = _typeof = function _typeof(obj) {
      return typeof obj;
    };

    module.exports["default"] = module.exports, module.exports.__esModule = true;
  } else {
    module.exports = _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };

    module.exports["default"] = module.exports, module.exports.__esModule = true;
  }

  return _typeof(obj);
}

module.exports = _typeof;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ })

},[["7Nrg",0,1,2,3,4,5,6,7,10,20]]]);